import React, { useState } from "react";
import { Col, Container, Row } from "react-bootstrap";
import ModalSkeleton from "../ModalSkeleton/ModalSkeleton";
import classes from "./LoginModal.module.css";
import MailIcon from "@mui/icons-material/Mail";
import Input from "../Input";
import LockIcon from "@mui/icons-material/Lock";
import Button from "../Button/Button";
import ForgotPassModal from "../../pages/ForgotPassModal/ForgotPassModal";
import { toast } from "react-toastify";
import { Post } from "../../Axios/AxiosFunctions";
import {
  BaseURL,
  formRegEx,
  formRegExReplacer,
  passwordRegex,
  validateEmail,
} from "../../config/apiUrl";
import { saveLoginUserData } from "../../redux/auth/authSlice";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";

const LoginModal = ({
  show,
  setShow,
  setShowForgotModal,
  setShowSignupModal,
}) => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loader, setLoader] = useState(false);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const handleSubmit = async (e) => {
    e.preventDefault();
    const data = {
      email: email,
      password: password,
    };
    for (var key in data) {
      if (data[key] == "")
        return toast.warn(
          `${key.replace(formRegEx, formRegExReplacer).trim()} cannot be empty`
        );
    }

    if (!validateEmail(email)) {
      return toast.warn("Please enter a valid email address");
    }
    if (password.length < 8) {
      return toast.warn("Please enter a correct password.");
    }

    // if (!passwordRegex.test(password))
    //   return toast.warn(
    //     "Password must contain 1 lowercase and 1 uppercase letter, along with 1 symbol."
    //   );
    setLoader(true);

    const response = await Post(BaseURL("users/login"), data, null);
    setLoader(false);

    if (response != undefined) {
      setShow(false);
      dispatch(saveLoginUserData(response?.data));
      navigate("/my-cards");
    }
  };
  return (
    <ModalSkeleton
      modalWidth={"28%"}
      modalPadding={"60px"}
      show={show}
      setShow={setShow}
      className={classes.modalMain}
    >
      <Container>
        <form onSubmit={handleSubmit}>
          <Row className={classes.input_mar}>
            <div className={"text-center"}>
              <h3>Welcome back</h3>
              <p style={{ color: "#929292" }}>
                Welcome back! Please enter your details
              </p>
            </div>
            <Col md={12}>
              <label>Email</label>

              <Input
                className={classes.cus_input}
                leftIcon={<MailIcon />}
                placeholder={"johndenly@info.com"}
                setter={setEmail}
                value={email}
              />
            </Col>
            <Col md={12}>
              <label>Password</label>

              <Input
                type={"password"}
                className={classes.cus_input}
                leftIcon={<LockIcon />}
                placeholder={"123*******"}
                setter={setPassword}
                value={password}
              />
            </Col>
            <div
              style={{
                marginTop: "5px",
                textAlign: "center",
                cursor: "pointer",
              }}
            >
              <p
                onClick={() => {
                  setShowForgotModal(true);
                  setShow(false);
                }}
              >
                Forgot Password?
              </p>
            </div>
            <div className={classes.lgn_btn_div}>
              <Button disabled={loader} type={"submit"} primary>
                {loader ? "Logging..." : " Login"}
              </Button>
              <p className="mt-2">
                Don't have a account?{" "}
                <span
                  className="c-p"
                  onClick={() => {
                    setShowSignupModal(true);
                    setShow(false);
                  }}
                >
                  Sign up for free
                </span>
              </p>
            </div>
          </Row>
        </form>
      </Container>
    </ModalSkeleton>
  );
};

export default LoginModal;
